import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Typography,
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  TextField,
  InputAdornment,
  Box,
  Chip,
  Menu,
  MenuItem,
  IconButton,
  Fade,
  Paper,
} from "@mui/material";
import {
  SearchRounded,
  FilterList,
  SortRounded,
  BookRounded,
  ArrowDownward,
} from "@mui/icons-material";
import placeholder from "./placeholder.png";
import SpinnerLoading from "../spinner/SpinnerLoading";
import "./libraryList.scss";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db, auth } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";

var queryConditon = orderBy("publish_on", "desc");

function LibraryList({ type }) {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  let dataValue;
  switch (type) {
    case "books":
      dataValue = {
        collectionVal: collection(db, "eLibrary"),
        emptyMessage:
          "No books found yet. Start adding some to build your library.",
        redirectVal: "library",
      };
      break;
    case "pending":
      dataValue = {
        collectionVal: collection(db, "pendingBooks"),
        emptyMessage:
          "No books found yet to approve. Start adding some to build your library.",
        redirectVal: "pending-books",
      };
      break;
    default:
      break;
  }

  const [Listofbooks, setListofbooks] = useState([]);
  const [lastKey, setLastKey] = useState();
  const [isLoading, setLoading] = useState(false);
  const [isEmpty, setEmpty] = useState(false);
  const [searchValue, setSearchVallue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (authLoading) return; // Wait for auth to load
    if (!user) return; // User not authenticated

    const publisherID = user.uid;
    const queryRef = query(
      dataValue.collectionVal,
      where("publisherID", "==", publisherID),
      queryConditon,
      limit(18)
    );
    getDocs(queryRef).then((querySnapshot) => {
      updateState(querySnapshot);
    });
    console.log(publisherID);
  }, [user, authLoading]);

  const updateState = (collections) => {
    const isCollectionEmpty = collections.size === 0;
    if (!isCollectionEmpty) {
      const books = collections.docs.map((book) => {
        const data = book.data();
        return { id: book.id, ...data };
      });
      const Lastdoc = collections.docs[collections.docs.length - 1];
      setListofbooks((Listofbooks) => [...Listofbooks, ...books]);
      setLastKey(Lastdoc);

      if (collections.size < 18) {
        setEmpty(true);
      }
    } else {
      setEmpty(true);
    }
    setLoading(false);
  };

  const fetchMorePosts = () => {
    if (!user) return;

    setLoading(true);
    setEmpty(false);

    const publisherID = user.uid;
    const queryRefAfter = query(
      dataValue.collectionVal,
      where("publisherID", "==", publisherID),
      queryConditon,
      startAfter(lastKey),
      limit(18)
    );
    getDocs(queryRefAfter).then((querySnapshot) => {
      updateState(querySnapshot);
    });
  };
  const fetchSearchData = () => {
    if (!user) return;

    setEmpty(false);
    const publisherID = user.uid;
    const queryRefAfter = query(
      dataValue.collectionVal,
      where("publisherID", "==", publisherID),
      queryConditon,
      limit(18)
    );
    getDocs(queryRefAfter).then((querySnapshot) => {
      updateState(querySnapshot);
    });
  };
  const onSearchClick = () => {
    const value = searchValue;
    if (value.length === 0) {
    } else {
      queryConditon = where("searchKeywords", "array-contains", value);
      setListofbooks([]);
      fetchSearchData();
    }
  };
  const handleSearchInput = (e) => {
    if (e.target.value.length === 0) {
      queryConditon = orderBy("publish_on", "desc");
      setListofbooks([]);
      fetchSearchData();
    }
    setSearchVallue(e.target.value);
  };

  const onSort = (value) => {
    queryConditon = value;
    setListofbooks([]);
    fetchSearchData();
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4, mt: 7 }}>
      {type === "books" && (
        <Paper elevation={2} sx={{ p: 2, mb: 4, borderRadius: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Box>
              <Button
                variant="outlined"
                startIcon={<FilterList />}
                onClick={handleClick}
                sx={{ mr: 2 }}
              >
                Sort & Filter
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
              >
                <MenuItem onClick={() => onSort(orderBy("name", "asc"))}>
                  <SortRounded sx={{ mr: 1 }} /> Alphabetical A-Z
                </MenuItem>
                <MenuItem onClick={() => onSort(orderBy("publish_on", "desc"))}>
                  <ArrowDownward sx={{ mr: 1 }} /> Most Recent
                </MenuItem>
              </Menu>

              {queryConditon.toString().includes("name") && (
                <Chip
                  label="Sorted: A-Z"
                  variant="outlined"
                  onDelete={() => onSort(orderBy("publish_on", "desc"))}
                  sx={{ mr: 1 }}
                />
              )}

              {queryConditon.toString().includes("searchKeywords") && (
                <Chip
                  label={`Search: ${searchValue}`}
                  variant="outlined"
                  onDelete={() => {
                    queryConditon = orderBy("publish_on", "desc");
                    setListofbooks([]);
                    setSearchVallue("");
                    fetchSearchData();
                  }}
                />
              )}
            </Box>

            <Box
              sx={{ display: "flex", flexGrow: 1, maxWidth: 500, ml: "auto" }}
            >
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search books..."
                value={searchValue}
                onChange={handleSearchInput}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={onSearchClick} edge="end">
                        <SearchRounded />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{ mr: 1 }}
              />
            </Box>
          </Box>
        </Paper>
      )}

      {Listofbooks.length === 0 && !isEmpty && (
        <Box sx={{ display: "flex", justifyContent: "center", my: 8 }}>
          <SpinnerLoading />
        </Box>
      )}

      {Listofbooks.length === 0 && isEmpty && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
            textAlign: "center",
          }}
        >
          <BookRounded
            sx={{ fontSize: 60, color: "text.secondary", mb: 2, opacity: 0.5 }}
          />
          <Typography variant="h5" color="text.secondary" gutterBottom>
            No Books Found
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {dataValue.emptyMessage}
          </Typography>
        </Box>
      )}

      {Listofbooks.length !== 0 && (
        <Box>
          <Grid container spacing={3}>
            {Listofbooks.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
                <Card
                  elevation={2}
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: 8,
                    },
                  }}
                >
                  <Box sx={{ position: "relative", pt: "140%" }}>
                    <CardMedia
                      component="img"
                      image={placeholder}
                      alt="Placeholder"
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <CardMedia
                      component="img"
                      image={item.thumbImage}
                      alt={item.name}
                      onLoad={(e) => {
                        e.target.style.opacity = 1;
                        const placeholderImg = e.target.previousSibling;
                        if (placeholderImg) {
                          placeholderImg.style.display = "none";
                        }
                      }}
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: 0,
                        transition: "opacity 0.7s ease",
                      }}
                    />
                  </Box>
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h2"
                      gutterBottom
                      noWrap
                      title={item.name}
                      sx={{ fontWeight: 600, fontSize: "1.1rem" }}
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        WebkitLineClamp: 3,
                        mb: 2,
                      }}
                    >
                      {item.about}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ p: 2, pt: 0 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      href={"/" + dataValue.redirectVal + "/" + item.id}
                      target="_blank"
                      sx={{ borderRadius: 2 }}
                    >
                      View eBook
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            {isLoading && (
              <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </Box>
            )}

            {!isLoading && !isEmpty && (
              <Button
                variant="contained"
                onClick={fetchMorePosts}
                size="large"
                sx={{ px: 4, py: 1, borderRadius: 2 }}
              >
                Load More eBooks
              </Button>
            )}
          </Box>
        </Box>
      )}
    </Container>
  );
}

export default LibraryList;
